import React from 'react';

import Chip from 'retired/Chip';
import { ActionVisibilityStatus } from 'generated/graphql';
import { primaryBlue, orange, white } from 'utils/color-styles';
import { capitalizeFirstLetter } from 'utils/stringFormat';

const getActionColor = (status?: ActionVisibilityStatus) => {
  switch (status) {
    case ActionVisibilityStatus.Published:
      return '#4DAD80';

    case ActionVisibilityStatus.Draft:
      return orange;

    default:
      return primaryBlue;
  }
};

export const ActionChip = ({ status }: { status: ActionVisibilityStatus }) => (
  <Chip
    label={capitalizeFirstLetter(status)}
    size="small"
    style={{
      paddingTop: 2,
      color: white,
      backgroundColor: getActionColor(status),
      borderColor: getActionColor(status),
      whiteSpace: 'nowrap',
    }}
  />
);
